import { Button } from '@/components/ui/Button/Button';
import { DialogBody, DialogFooter } from '@/components/ui/Dialog/Dialog';
import { Illustration, type IllustrationType } from '@/components/ui/Illustration/Illustration';
import { captureAnalyticsEvent } from '@/lib/mixpanel';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useScheduleFlow } from '../../context/useScheduleFlow';

interface ErrorStepProps {
  onClose: () => void;
}

export const ErrorStep = ({ onClose }: ErrorStepProps) => {
  const { t } = useTranslation('scheduling', { keyPrefix: 'scheduleDialog.steps.errorStep' });
  const { goToStep, errorType, setErrorType } = useScheduleFlow();

  const goToChooseDateStep = () => {
    void captureAnalyticsEvent('scheduling_seattaken_adjustdate');
    setErrorType(undefined);
    goToStep('dateAndTime');
  };

  let title: string = t('types.generic.title');
  let description: string = t('types.generic.description');
  let illustrationName: IllustrationType = 'problem';
  let Footer: React.ReactNode = (
    <>
      <Button type='button' variant='text-secondary' onClick={onClose} className='flex-1'>
        <span>{t('types.generic.leaveButton.label')}</span>
      </Button>
      <Button onClick={goToChooseDateStep} className='flex-1'>
        {t('types.generic.changeDateButton.label')}
      </Button>
    </>
  );

  switch (errorType) {
    case 'fullyBooked': {
      title = t('types.fullyBooked.title');
      description = t('types.fullyBooked.description');
      illustrationName = 'problem';
      Footer = (
        <>
          <Button type='button' variant='text-secondary' onClick={onClose} className='flex-1'>
            <span>{t('types.fullyBooked.leaveButton.label')}</span>
          </Button>
          <Button onClick={goToChooseDateStep} className='flex-1'>
            {t('types.fullyBooked.changeDateButton.label')}
          </Button>
        </>
      );
      break;
    }
  }

  return (
    <>
      <DialogBody className='flex h-full flex-1 flex-col'>
        <div className='-mt-16 flex flex-1 flex-col items-center justify-center text-center'>
          <Illustration name={illustrationName} className='m-3 w-[127px]' />
          <p className='text-heading-m-semibold mt-6 mb-4 w-[320px] max-w-full'>{title}</p>
          <p className='text-text-default-secondary w-[320px] max-w-full'>{description}</p>
        </div>
      </DialogBody>
      <DialogFooter>{Footer}</DialogFooter>
    </>
  );
};
